/**
 * Checkout Page has a Payment button, and a button on mobile screen which opens payment modal
 - default - By default the button on mobile is called 'Next' and the payment button
 * is 'Pay <amount>'
 - custom - In 'custom' button type we can update the text of these two buttons
 */
export const checkout_page_button_types = {
  default: 1,
  custom: 2,
};

export const CHECKOUT_PAGE_SIGNZY_CONTRACT_STATUS = {
  CREATED: 1,
  CACHED: 2,
  SIGNED_FOR_TODAY: 3,
  ERROR: 4,
} as const;

export const SIGNZY_CONTRACT_STATE_STATUS = {
  INITIATED: "INITIATED",
  PENDING: "PENDING",
  EXPIRED: "EXPIRED",
  REJECTED: "REJECTED",
  DELETED: "DELETED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
};

export const SIGNZY_CONTRACT_STATE_KEY = "contract_state";

export const ESIGN_PLACEMENT = {
  BEFORE_BOOKING: 1,
  AFTER_BOOKING: 2,
};
